import React from "react";
import { useAutocompleteOption } from "../useAutocomplete";
import classNames from "classnames";

const AutocompleteOption = ({
  id,
  path,
  selected,
  onSelect,
  onClick,
  children,
}) => {
  const [isSelected, autocompleteProps] = useAutocompleteOption(
    id,
    path,
    selected,
    onSelect
  );

  return (
    <li
      {...autocompleteProps}
      onClick={onClick}
      className={classNames("autocomplete-results__option", {
        "autocomplete-results__option--selected": isSelected,
      })}
    >
      {children}
    </li>
  );
};

export default AutocompleteOption;
